<template>
  <div>
    <div
      class="flex justify-center items-center w-100"
      @parserpopup="parserPopup"
    >
      <section
        class="w-full flex justify-center"
        style="min-width: 500px;"
        v-if="!wrongJsonResponse"
      >
        <!-- animated card  -->
        <vs-card v-show="isScanningCard" class="scanning-override-card">
          <div class="radar-parsing-state">
            
            <div class="radar-document-container">
              <!-- Roaming Magnifying Glass -->
              <div class="mag-glass-wrapper">
                <div class="mag-glass"></div>
                <div class="mag-handle"></div>
              </div>

              <!-- Skeleton UI -->
              <div class="sk-header">
                <div class="sk-avatar"></div>
                <div class="sk-lines">
                  <div class="sk-line w-60"></div>
                  <div class="sk-line w-40"></div>
                </div>
              </div>
              <div class="sk-body">
                <div class="sk-line w-90"></div>
                <div class="sk-line w-80"></div>
                <div class="sk-line w-85"></div>
                <div class="sk-line w-50 mt-3"></div>
                <div class="sk-line w-75"></div>
                <div class="sk-line w-80 mt-3"></div>
                <div class="sk-line w-60"></div>
              </div>

              <!-- The Sweeping Laser -->
              <div class="scanner-laser-group">
                <div class="scanner-gradient"></div>
                <div class="scanner-line"></div>
              </div>

              <!-- Dynamic Floating Badges with Connectors -->
              <div class="float-badge badge-1">
                <span class="badge-dot"></span> 🔍 Tech Stack
                <div class="connector-line left-line"></div>
              </div>
              <div class="float-badge badge-2">
                <div class="connector-line right-line"></div>
                ⚡ Velocity <span class="badge-dot"></span>
              </div>
              <div class="float-badge badge-3">
                <span class="badge-dot"></span> 🧠 HR Intel
                <div class="connector-line left-line"></div>
              </div>
              <div class="float-badge badge-4">
                <div class="connector-line right-line"></div>
                🎯 Trajectories <span class="badge-dot"></span>
              </div>
            </div>

            <h3 class="radar-title">DEEP AI SCAN IN PROGRESS</h3>
            <p class="radar-status-text">{{ scanStatusText }}</p>

          </div>
        </vs-card>
        <!-- animated card  -->

        <!-- json response  -->
        <vs-popup title="" :active.sync="jsonResponsePopup">
          <vs-card class="m-0 md:px-6 md:py-2">
            <h4 class="font-semibold text-2xl">Review your Data</h4>
            <div class="vx-row mt-4 relative">
              <vs-card class="w-full json_response">
                <pre> <vue-json-pretty :path="'res'" :data="jsonResponse" :deep="1">
          </vue-json-pretty
        ></pre>
              </vs-card>

              <span class="buttons flex justify-between w-full">
                <div
                  class="button button--incorrect flex items-center cursor-pointer"
                  @click="wrongResponse()"
                >
                  <h5 class="font-semibold button--incorrect-text">
                    My data isn’t correct
                  </h5>
                </div>

                <div
                  class="button button--correct flex items-center cursor-pointer"
                  @click="selectFieldToSync()"
                >
                  <h5 class="font-semibold button--correct-text capitalize">
                    Continue to sync
                  </h5>
                </div>
              </span>
            </div>
          </vs-card>
        </vs-popup>
        <!-- json response  -->

        <!-- select field to be sync with editor popup -->
        <vs-popup title="" :active.sync="isSelectFieldCard">
          <vs-card class="m-0 md:py-2">
            <vs-row class="items-center justify-between">
              <div class="">
                <h4 class="font-semibold text-2xl">
                  Select Field you want to sync
                </h4>
              </div>
              <div class="flex">
                <h4 class="font-semibold text-2xl mr-1">Select All</h4>
                <vs-checkbox
                  class="whitespace-no-wrap float-right items-right"
                  @change="selectAll(selectFields, $event)"
                  v-model="selectall"
                ></vs-checkbox>
              </div>
            </vs-row>
            <vs-row class="md:my-6">
              <vs-col
                v-for="(k, v) in selectFields"
                :key="k.key"
                class="vs-sm-12 vs-lg-6"
              >
                <div
                  class="parser-item field__container md:m-3 flex items-center p-1"
                  :class="
                    Array.isArray(selectedFields) &&
                    selectedFields.includes(k.comparedKey)
                      ? 'field__container--selected'
                      : ''
                  "
                >
                  <div>
                    <div class="con-vs-avatar">
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Personal Details'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/about.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Skills'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/skills.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Project'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/projects.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Education'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/educational-qualifications.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Experience'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/career-history.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Languages'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/Languages.svg"
                          class="w-8"
                          style="width: 35px; height: 35px"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Certificates'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/Certificates.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Interests'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/Interests.svg"
                          class="w-8"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    class="w-full flex items-center justify-between overflow-hidden"
                  >
                    <div class="flex flex-col truncate w-5/6 items-left">
                      <h5 class="font-semibold">
                        {{ selectFields[v].title }}
                      </h5>
                    </div>
                    <div class="flex self-start flex-col items-end w-1/6">
                      <span class="whitespace-no-wrap"
                        ><vs-checkbox
                          :v-model="selectFields[v].value"
                          :checked="selectAllStatus"
                          @change="
                            selectOption(selectFields[v].comparedKey, $event)
                          "
                        ></vs-checkbox
                      ></span>
                    </div>
                  </div>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="buttons flex justify-end w-full">
              <div
                class="button button--correct flex items-center cursor-pointer"
                :class="selectedFields.length <= 2 ? 'button--deactivate' : ''"
                @click="syncSelectedParsedData()"
              >
                <h4 class="font-semibold button--correct-text">
                  Sync data with editor
                </h4>
              </div>
            </vs-row>
          </vs-card>
        </vs-popup>
        <!--// select field to be sync with editor popup  -->
      </section>
      <section v-else class="wrong-json-popup">
        <vs-popup title="" :active.sync="isWrongJsonPopup">
          <vs-card class="m-0 md:py-2">
            <vs-row class="items-center justify-between">
              <div class="">
                <h4 class="font-semibold text-2xl">
                  Tell us where we went wrong
                </h4>
              </div>
              <div class="flex">
                <h4 class="font-semibold text-2xl mr-1">Select All</h4>
                <vs-checkbox
                  class="whitespace-no-wrap float-right items-right"
                  @change="selectAll(selectFields, $event)"
                  v-model="selectall"
                ></vs-checkbox>
              </div>
            </vs-row>
            <vs-row class="md:my-6">
              <vs-col
                v-for="(k, v) in selectFields"
                :key="k.key"
                class="vs-sm-12 vs-lg-6"
              >
                <div
                  class="parser-item field__container md:m-3 flex items-center p-1"
                  :class="
                    Array.isArray(selectedFields) &&
                    selectedFields.includes(k.comparedKey)
                      ? 'field__container--selected'
                      : ''
                  "
                >
                  <div>
                    <div class="con-vs-avatar">
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Personal Details'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/about.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Skills'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/skills.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Project'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/projects.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Education'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/educational-qualifications.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Experience'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/career-history.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Languages'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/Languages.svg"
                          class="w-8"
                          style="width: 35px; height: 35px"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Certificates'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/Certificates.svg"
                          class="w-8"
                        />
                      </div>
                      <div
                        class="con-img vs-avatar--con-img"
                        v-if="selectFields[v].title === 'Interests'"
                      >
                        <img
                          src="../../../../src/assets/images/icons/Interests.svg"
                          class="w-8"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    class="w-full flex items-center justify-between overflow-hidden"
                  >
                    <div class="flex flex-col truncate w-5/6 items-left">
                      <h5 class="font-semibold">
                        {{ selectFields[v].title }}
                      </h5>
                    </div>
                    <div class="flex self-start flex-col items-end w-1/6">
                      <span class="whitespace-no-wrap"
                        ><vs-checkbox
                          :v-model="selectFields[v].value"
                          :checked="selectAllStatus"
                          @change="
                            selectOption(selectFields[v].comparedKey, $event)
                          "
                        ></vs-checkbox
                      ></span>
                    </div>
                  </div>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="buttons flex justify-end w-full">
              <div
                class="button button--correct flex items-center cursor-pointer"
                :class="selectedFields.length > 0 ? '' : 'button--deactivate'"
                @click="submitFeedback()"
              >
                <h4 class="font-semibold button--correct-text">
                  Submit feedback
                </h4>
              </div>
            </vs-row>
          </vs-card>
        </vs-popup>
      </section>
    </div>
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import axios from "axios";
import constants from "@/constants.js";

export default {
  name: "EditorResumeParser",
  components: {
    VueJsonPretty,
  },
  props: ["parsingFile"],
  data() {
    return {
      scanStatusText: "Structuring document nodes...", // <--- ADD THIS
      isScanningCard: true,
      jsonResponse: {},
      wrongJsonResponse: false,
      selectFields: [
        { title: "Personal Details", value: "False", key: "personal_details", comparedKey: "personal_details" },
        { title: "Skills", value: "False", key: "skills", comparedKey: "skills" },
        { title: "Project", value: "False", key: "projects", comparedKey: "projects" },
        { title: "Education", value: "False", key: "educational_details", comparedKey: "education_details" },
        { title: "Experience", value: "False", key: "work_experience", comparedKey: "work_details" },
        { title: "Languages", value: "False", key: "languages", comparedKey: "languages" },
        { title: "Certificates", value: "False", key: "certificates", comparedKey: "certifications" },
        { title: "Interests", value: "False", key: "interests", comparedKey: "interests" },
      ],
      selectedFields: ["predicted_competency", "predicted_characteristics"],
      parserPopup: false,
      fData: new FormData(),
      selectall: false,
      fName: null,
      selectAllStatus: false,
      file: "",
      isSelectFieldCard: false,
      jsonResponsePopup: false,
      isWrongJsonPopup: false,
      resumeFile: "",
    };
  },
  watch: {
    parsingFile(newVal) {
      if (newVal) {
        this.resumeFile = newVal;
        this.parseResume(newVal);
      }
    },
  },
  methods: {
    selectAll(t, event) {
      if (this.selectall) {
        if (event.target.checked) {
          this.selectAllStatus = true;
          for (let i = 0; i < t.length; i++) {
            this.selectedFields.push(t[i].comparedKey);
          }
        }
      } else {
        this.selectAllStatus = false;
        for (let i = 0; i < t.length; i++) {
          this.selectedFields.pop(t[i].comparedKey);
        }
      }
    },
    selectOption(t, event) {
      if (event.target.checked) {
        this.selectedFields.push(t);
      } else {
        this.selectedFields = this.selectedFields.filter((item) => item !== t);
      }
    },
    wrongResponse() {
      this.selectedFields = [];
      this.wrongJsonResponse = true;
      this.isWrongJsonPopup = true;
    },
    submitFeedback() {
      this.isWrongJsonPopup = false;
      this.$emit("parserpopup", { popup: false });
      const payload = {
        fileName: this.jsonResponse.resume_file ? this.jsonResponse.resume_file.fileName : this.fName,
        wrongFields: this.selectedFields,
      };
      axios.post(`${constants.parserFeedbackApi}`, payload)
        .then((res) => console.log("Feedback submitted", res))
        .catch((err) => console.log("Feedback error", err));
    },

    // --- UPDATED METHOD: Hits your new Sync API (Removed generic loader) ---
    parseResume(file) {
      if (file) {
        this.fName = file.name;
        if (file.size <= 5242880) { // Max 5MB
          // Show ONLY the nice animated card, do NOT show the spinner
          this.isScanningCard = true;

          this.scanStatusText = "Structuring document nodes...";
          setTimeout(() => { if (this.isScanningCard) this.scanStatusText = "Extracting skills and history..."; }, 2500);
          setTimeout(() => { if (this.isScanningCard) this.scanStatusText = "Simulating career pathways..."; }, 5000);
          setTimeout(() => { if (this.isScanningCard) this.scanStatusText = "Finalizing data sync..."; }, 7500);

          // Build form data exactly as your backend expects
          let formData = new FormData();
          formData.append("file", file);
          formData.append("user_id", this.$store.state.auth.user._id);
          
          // Get the Token (adjust if your app stores it differently)
          const token = this.$store.state.auth.accessToken || localStorage.getItem("accessToken") || localStorage.getItem("token") || "";
          formData.append("api_token", token);

          // Get the Base URL from constants. Adjust 'http://localhost:8000' if needed to match your backend port
          const baseURL = "https://parser.ai.getboarded.com";

          axios
            .post(`${baseURL}/sync-resume/`, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
              // Hide the animated card
              this.isScanningCard = false;
              this.$emit("parserpopup", false); // Close modal automatically
              
              this.$vs.notify({
                title: 'Success',
                text: 'Resume successfully parsed and automatically synced to your profile!',
                color: 'success',
                icon: 'check_circle'
              });
            })
            .catch((err) => {
              console.log("Sync Error:", err);
              // Hide the animated card
              this.isScanningCard = false;
              
              let errorMessage = 'An error occurred while processing the resume.';
              if (err.response && err.response.data && err.response.data.detail) {
                errorMessage = err.response.data.detail;
              }

              this.$vs.notify({
                title: 'Parsing Failed',
                text: errorMessage,
                color: 'danger',
                icon: 'error'
              });
            });
        } else {
          this.$vs.notify({
            title: "File size large",
            text: "File size max 5MB",
            color: 'warning'
          });
        }
      }
    },
    getPersonality() {
      this.$vs.loading();

      axios
        .post(`${constants.personalityAPI}`, this.fPersonalityData)
        .then((res) => {
          if (res.data.length) {
            res.data.forEach((item) => {
              this.finalResponse = { ...this.finalResponse, ...item };
            });
            this.$store.commit("parser/SET_JSON_RESPONSE", this.finalResponse);
            this.jsonResponse = this.finalResponse;
            this.isScanningCard = false;
            this.$emit("parserpopup", { popup: false });
            this.jsonResponsePopup = true;
          }
          this.$vs.loading.close();
        })
        .catch(function (error) {
          this.$vs.loading.close();
          throw error;
        });
    },
    selectFieldToSync() {
      this.jsonResponsePopup = false;
      this.isSelectFieldCard = true;
    },
  },
  created() {
    this.jsonResponse = "";
    this.selectFields.forEach((element) => {
      this.fData.append(element.key, "True");
    });
    this.fData.append("file", "");
  },
};
</script>

<style lang="scss" scoped>
section {
  height: 75%;
  align-items: center;
}

/* --- OVERRIDE VUE CARD SO BADGES DONT GET CUT OFF --- */
.scanning-override-card {
  box-shadow: none !important;
  background: transparent !important;
  border: none !important;
}
.scanning-override-card ::v-deep .vs-card--content {
  overflow: visible !important; /* CRITICAL: Allows floating badges to overflow */
  padding: 0 !important;
}

/* --- DEEP AI SCAN UI --- */
.radar-parsing-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 450px; /* Guarantees enough space for the radar */
  padding: 2rem 0;
}

.radar-title {
  font-size: 1.3rem; 
  font-weight: 800;
  color: #111827;
  margin: 2rem 0 0.5rem 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  text-align: center;
  white-space: nowrap; /* Prevents the text from wrapping */
}
.radar-status-text {
  font-size: 0.95rem; 
  font-weight: 600;
  color: #F59E0B; 
  margin: 0;
  height: 24px; 
  text-align: center;
  animation: pulseText 1.5s infinite;
}

@keyframes pulseText { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }

.radar-document-container {
  position: relative;
  width: 320px !important; /* Locked width - prevents squishing */
  height: 400px !important; /* Locked height */
  flex-shrink: 0; /* Tells the browser NEVER to crush this element */
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  box-shadow: 0 15px 35px rgba(0,0,0,0.08);
  margin: 0 auto;
}

/* Skeleton UI Elements */
.sk-header { display: flex; gap: 1.5rem; margin-bottom: 2rem; }
.sk-avatar { width: 50px; height: 50px; border-radius: 50%; background: #F3F4F6; }
.sk-lines { flex: 1; display: flex; flex-direction: column; gap: 0.6rem; justify-content: center; }
.sk-line { height: 10px; background: #F3F4F6; border-radius: 5px; }
.w-90 { width: 90%; } .w-85 { width: 85%; } .w-80 { width: 80%; } 
.w-75 { width: 75%; } .w-60 { width: 60%; } .w-50 { width: 50%; } .w-40 { width: 40%; }
.mt-3 { margin-top: 1.5rem; }

/* The Sweeping Laser */
.scanner-laser-group {
  position: absolute;
  left: 0; right: 0; top: 0;
  height: 100px; 
  transform: translateY(-100%);
  animation: sweepRadar 3.5s cubic-bezier(0.4, 0, 0.2, 1) infinite alternate;
  pointer-events: none;
  z-index: 10;
  border-radius: 16px;
  overflow: hidden;
}
.scanner-line {
  position: absolute; bottom: 0; width: 100%; height: 3px;
  background: #FBB603; box-shadow: 0 0 10px #FBB603, 0 0 20px #F59E0B;
}
.scanner-gradient {
  position: absolute; bottom: 3px; width: 100%; height: 100%;
  background: linear-gradient(to top, rgba(251, 182, 3, 0.2) 0%, rgba(251, 182, 3, 0) 100%);
}
@keyframes sweepRadar {
  0% { transform: translateY(-100%); }
  100% { transform: translateY(420px); }
}

/* Magnifying Glass Roaming */
.mag-glass-wrapper {
  position: absolute;
  z-index: 15;
  top: 20%; left: 20%;
  animation: roamGlass 8s ease-in-out infinite alternate;
  pointer-events: none;
}
.mag-glass {
  width: 80px; height: 80px;
  border-radius: 50%;
  border: 4px solid rgba(251, 182, 3, 0.8);
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px); 
  box-shadow: inset 0 0 15px rgba(251, 182, 3, 0.3), 0 10px 20px rgba(0,0,0,0.1);
}
.mag-handle {
  position: absolute;
  bottom: -25px; right: -15px;
  width: 12px; height: 40px;
  background: #D1D5DB;
  border-radius: 6px;
  transform: rotate(-45deg);
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}
@keyframes roamGlass {
  0% { transform: translate(0, 0) scale(1); }
  25% { transform: translate(120px, 40px) scale(1.1); }
  50% { transform: translate(40px, 180px) scale(0.9); }
  75% { transform: translate(-30px, 120px) scale(1.05); }
  100% { transform: translate(80px, 220px) scale(1); }
}

/* Floating Pop-up Badges */
.float-badge {
  position: absolute;
  background: white;
  border: 1px solid #FDE68A;
  color: #111827;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(251, 182, 3, 0.15);
  z-index: 20;
  opacity: 0;
  white-space: nowrap;
  animation: popInOut 6s infinite;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.badge-dot { width: 8px; height: 8px; background: #10B981; border-radius: 50%; box-shadow: 0 0 8px #10B981; }

.connector-line {
  position: absolute; top: 50%; height: 2px; background: #FDE68A; width: 30px; z-index: -1;
}
.left-line { right: -30px; } 
.right-line { left: -30px; } 

.badge-1 { top: 15%; left: -35%; animation-delay: 0.2s; }
.badge-2 { top: 40%; right: -35%; animation-delay: 2s; }
.badge-3 { top: 65%; left: -35%; animation-delay: 3.8s; }
.badge-4 { top: 85%; right: -35%; animation-delay: 5.5s; }

@keyframes popInOut {
  0% { opacity: 0; transform: scale(0.8); }
  10% { opacity: 1; transform: scale(1); }
  40% { opacity: 1; transform: scale(1); }
  50% { opacity: 0; transform: scale(0.8); }
  100% { opacity: 0; }
}

/* --- JSON POPUPS CSS PRESERVED --- */
.json_response {
  background-color: #1b1b1b;
  height: 35em !important;
  overflow: scroll;
  &::-webkit-scrollbar-track {
    background-color: #1b1b1b;
  }
  &::-webkit-scrollbar {
    width: 10px;
  }
}

.buttons {
  .button {
    border-radius: 8px;
    padding: 1em 2em;
    &--incorrect {
      border: 5px solid rgba(179, 186, 196, 0.5);
      &-text {
        color: #818181;
      }
    }
    &--correct {
      background: linear-gradient(90deg, #f8be17 0%, #ffce42 101.56%);
    }
    &--deactivate {
      opacity: 0.5;
      cursor: not-allowed !important;
    }
  }
}

.wrong-json-popup { height: 60%; }

.field {
  &__container {
    border: 2px solid #ebedf0;
    border-radius: 5px;
    padding: 0.75em 1em;
    &--selected {
      background: rgba(242, 194, 68, 0.05);
      border-color: #f2c244;
    }
  }
  &__title {
    color: #8692a6;
  }
}

.con-vs-avatar {
  width: 35px;
  height: 35px;
}
</style>

<style scoped>
.con-vs-card >>> .vs-card--content {
  margin: 0;
}
</style>


